import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import Icon from 'eventbrite_design_system/icon/Icon';
import { ICON_TYPE_PROP_TYPE } from 'eventbrite_design_system/icon/constants';

import './pageHeader.scss';

const HeaderIcon = ({ iconType }) => {
    const classes = classNames(
        'eds-l-mar-bot-6',
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        `header-icon--${iconType}`,
    );

    return (
        <div className={classes}>
            <Icon size="medium" type={iconType} color="ui-orange" />
        </div>
    );
};

const HeaderTitle = ({ headerText, subtitleText, shouldShowAUSignUp }) => {
    const headerTitleClasses = classNames(
        'eds-text-hs',
        {
            'eds-l-mar-bot-10': !shouldShowAUSignUp,
        },
        {
            'eds-l-mar-bot-8': shouldShowAUSignUp && !subtitleText,
        },
    );

    return <div className={headerTitleClasses}>{headerText}</div>;
};

const HeaderSubTitle = ({ subtitleText, shouldShowAUSignUp }) => {
    let component = null;

    const headerSubTitleClasses = classNames(
        //Adding the set style so that the subtitle text maintains consistent height as text length changes with screen size.
        //Prevents email field from jumping around the page.
        'eds-l-mar-bot-8',
        'eds-text-color--grey-600',
        'eds-l-mar-hor-3',
        {
            'eds-text-bm': !shouldShowAUSignUp,
        },
        {
            'eds-text-bs': shouldShowAUSignUp,
        },
    );

    if (subtitleText) {
        component = <div className={headerSubTitleClasses}>{subtitleText}</div>;
    }

    return component;
};

export default class PageHeader extends React.PureComponent {
    static propTypes = {
        headerText: EBPropTypes.translation.isRequired,
        iconType: ICON_TYPE_PROP_TYPE.isRequired,
        subtitleText: EBPropTypes.translation,
        iconColor: PropTypes.string,
    };

    static defaultProps = {
        iconColor: 'grey-900',
    };

    render() {
        const {
            headerText,
            subtitleText,
            iconType,
            iconColor,
            shouldShowAUSignUp,
        } = this.props;

        return (
            <div className="authentication__page-header eds-text--center">
                <HeaderIcon iconType={iconType} iconColor={iconColor} />
                <HeaderTitle
                    headerText={headerText}
                    subtitleText={subtitleText}
                    shouldShowAUSignUp={shouldShowAUSignUp}
                />
                <HeaderSubTitle
                    subtitleText={subtitleText}
                    shouldShowAUSignUp={shouldShowAUSignUp}
                />
            </div>
        );
    }
}
